module.exports = __webpack_public_path__ + "media/images/beach-4-21550b04.jpg";